import {
  Column,
  Columns,
  EmptyState,
  FlexBox,
  Spinner,
} from '@dixa/lib-shared-habla';

import { QuickView } from './components/quickView/quickView';
import { useQuickViewInit } from './utils/useQuickViewInit/useQuickViewInit';

export const QuickViewView = (): JSX.Element => {
  const { quickView, asyncStatus } = useQuickViewInit();

  if (asyncStatus === 'fulfilled' && quickView) {
    return <QuickView quickView={quickView} />;
  }

  const isLoading =
    asyncStatus === 'uninitialized' || asyncStatus === 'pending';
  const isError = asyncStatus === 'rejected';

  return (
    <Columns>
      <Column>
        <Column.Row slottable borderBottom></Column.Row>

        <Column.Row scrollable>
          {isLoading && (
            <FlexBox height="100%" alignItems="center" justifyContent="center">
              <Spinner />
            </FlexBox>
          )}

          {isError && (
            <FlexBox height="100%" alignItems="center" justifyContent="center">
              <EmptyState
                title="Something went wrong"
                description="We're experiencing some issues, try again or reload the page. If this issue persists, please contact support."
                icon="exclamation"
                iconColor="red.500"
              />
            </FlexBox>
          )}
        </Column.Row>
      </Column>
    </Columns>
  );
};
